// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  backendMapURL: "https://maps.googleapis.com",
  // https://luxapi.zimblecode.com/

  firebase: {
    apiKey: "AIzaSyB3wNqlrFd0_DIeFwsZYC_mvSYSyduCTsM",
    authDomain: "lux-enroute.firebaseapp.com",
    projectId: "lux-enroute",
    storageBucket: "lux-enroute.firebasestorage.app",
    messagingSenderId: "1033377039888",
    appId: "1:1033377039888:web:fb186e6bb0199fab052c95",
    measurementId: "G-FP9QTVYGLR",
    vapidKey: "BHUTLVu0AII4FCbY5W8CjRvThxkaBBsySf7GKO6Y95qodAuJJWlDo8YcVQln6L7EKui2ZYhtvnj8yLLjBtnCjvw"
  },
};
// for prod
// {
//   "backendApiURL": "https://api.luxenroute.com/"
// }

// for dev
// {
//   "backendApiURL": "https://apiluxdelivery.codknox.com/"
// }
